import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import type { AthleticsTeamMembers } from '@/types/enrollments'

// GET /ajax/athletics/{enrollmentId}/members (DTA-799)
//
// A 403 here means the team's "publish members" switch is off, not that the
// session died — so the auth redirect is suppressed and the caller shows the
// server's failure_reason instead.
export const athleticsTeamMembers = async (enrollmentId: number): Promise<AthleticsTeamMembers> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).get(
    '/ajax/athletics/' + enrollmentId + '/members'
  )
  return Util.Obj.keysToCamel({
    team: response.data.team,
    members: response.data.members ?? [],
    coaches: response.data.coaches ?? [],
    // Round 9: staff roles + the sport's vocabulary; absent on older servers.
    staff: response.data.staff ?? [],
    vocabulary: response.data.vocabulary ?? null
  }) as AthleticsTeamMembers
}
